import React, {Component} from "react";
import swal from "sweetalert";

const DEFAULT_INPUT_TEXT = 0;

class Spinner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: DEFAULT_INPUT_TEXT,
        };
    }

    changeText(e) {
        let text = e.target.value;

        this.setState({
            text,
        });

        swal.setActionValue(text);
    }

    render() {
        return (
            <div>
                <h4>
                    {this.state.text}
                </h4>
                <input
                    type="range"
                    min="0"
                    max="100"
                    step="1"
                    value={this.state.text}
                    onChange={this.changeText.bind(this)}
                />
            </div>
        )
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Promo/Calls/Spinner.js